import React, { useMemo, useRef, useState } from "react"
import ReportColumnSelector from "components/Common/ReportColumnSelector"
import { Button, Col, Form, Input, Label, Row } from "reactstrap"

import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import moment from "moment"
import { useSelector, useDispatch } from "react-redux"
import { isObject } from "lodash"
import Select from "react-select"
import { getProviderItems } from "store/provider-dashboard/provider-dashboard-action"
import {
  getProviderConsumptionsFacilities,
  getProviderConsumptionsIPs,
  getProviderConsumptionsProvince,
} from "store/provider-consumption/province-consumption-action"
import { providerReportsAction } from "store/provider-reports/p-report-slice"
import { providerConsumptionAction } from "store/provider-consumption/province-consumption-slice"

const ProviderConsumptionReporFilter2 = ({
  onAdvancedSearchSubmit,
  loading,
  error,
  columns = [],
  onToggleColumn = () => {},
  onReorder = () => {},
}) => {
  const dateFlatpickerfrom = useRef(null)
  const dateFlatpickerto = useRef(null)
  const [category, setCategory] = useState(null)
  const [item, setItem] = useState(null)
  const [batch_number, setBatchNumber] = useState("")
  const [project, setProject] = useState(null)
  const [province, setProvince] = useState(null)
  const [facility, setFacility] = useState(null)
  const [ip, setIP] = useState(null)

  const dispatch = useDispatch()

  const [date, setDate] = useState({
    from: null,
    to: null,
  })

  // Retrieve categories data from Redux store
  const categories = useSelector(
    state => state.providerDashboard.ProviderItemCategoires
  )

  // Retrieve projects data from Redux store
  const projects = useSelector(
    state => state.providerConsumptions.providerConsumpProjects
  )

  // Retrieve ips data from Redux store
  const ips = useSelector(
    state => state.providerConsumptions.providerConsumpIPs
  )

  // Retrieve ips data from Redux store
  const items = useSelector(state => state.providerDashboard.ProviderItems)

  // Retrieve ips data from Redux store
  const provinces = useSelector(
    state => state.providerConsumptions.providerConsumpProvinces
  )
  // Retrieve facilities data from Redux store
  const facilities = useSelector(
    state => state.providerConsumptions.providerConsumpFacilities
  )

  // get filtered items based select box props needs
  const filteredItems = useMemo(
    () =>
      items?.data.map(item => ({
        value: item.id,
        label: `${item.unfp_item_name} ( ${item.item_name} )`,
      })),
    [items]
  )

  // Store filtered data and dispatch the action using onAdvancedSearchSubmit callback function
  const handleSubmit = () => {
    let data = {}

    data.date = {
      from: date.from ? date.from : null,
      to: date.to ? date.to : null,
    }
    if (item) {
      data.item = item.map(ite => (ite.value ? ite.value : ite))
    }
    if (facility) {
      data.facility = facility.map(ite => (ite.value ? ite.value : ite))
    }

    data.category = isObject(category) ? category.value : null
    data.project_id = isObject(project) ? project.value : null
    data.ip_id = isObject(ip) ? ip.value : null
    data.province = isObject(province) ? province.value : null
    // data.facility = isObject(facility) ? facility.value : null
    data.batch_number = batch_number
    onAdvancedSearchSubmit(data)
  }

  // clear search when clear button clicked
  const onClearHandler = () => {
    dateFlatpickerfrom.current.flatpickr.clear()
    dateFlatpickerto.current.flatpickr.clear()
    setItem(null)
    setCategory(null)
    setBatchNumber("")
    setDate({ from: null, to: null })
    setProject(null)
    setProvince(null)
    setFacility(null)
    setIP(null)
    dispatch(providerConsumptionAction.resetState())
    onAdvancedSearchSubmit({})
  }

  // store Item Categories and fetch items based item category
  const onCategoryChangeHandler = cate => {
    setCategory(cate)
    dispatch(getProviderItems(cate.value))
  }

  // store multiple items based selected
  const onItemChangeHandler = item => {
    const check = item.some(ite => ite.value === "all")
    if (check) {
      setItem(filteredItems)
    } else {
      setItem(item)
    }
  }
  // store proejct value and fetch consumption ips based project id
  const onProjectChangeHandler = proj => {
    dispatch(getProviderConsumptionsIPs({ project_id: proj.value }))
    setProject(proj)
  }

  // store ip value
  const onIPChangeHandler = ips => {
    setIP(ips)
    dispatch(
      getProviderConsumptionsProvince({
        ip_id: ips.value,
        project_id: project.value,
      })
    )
  }

  // store province value and fetch facilities based province id
  const onProvinceChangeHandler = prov => {
    setProvince(prov)
    setFacility("")
    dispatch(
      getProviderConsumptionsFacilities({
        ip_id: ip?.value,
        province_id: prov.value,
        project_id: project.value,
      })
    )
  }

  // store facility value
  const onFacilityChangeHandler = value => {
    const check = value.some(ite => ite.value === "all")
    if (check) {
      setFacility(facilities?.data)
    } else {
      setFacility(value)
    }
  }

  // store batch number
  const onBatchNumberChange = batch_number => {
    setBatchNumber(batch_number.target.value)
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
        return false
      }}
    >
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Projects</Label>
            {projects?.data && (
              <Select
                options={projects?.data}
                value={project}
                onChange={onProjectChangeHandler}
              />
            )}
            {error?.errors?.project?.[0] && (
              <p className="text-danger">{error?.errors?.project?.[0]}</p>
            )}
          </Col>
          <Col>
            <Label className="form-label">IPs</Label>
            {ips?.data && (
              <Select
                options={ips?.data}
                value={ip}
                onChange={onIPChangeHandler}
              />
            )}
            {error?.errors?.ip_id?.[0] && (
              <p className="text-danger">{error?.errors?.ip_id?.[0]}</p>
            )}
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Provinces</Label>
            {provinces?.data && (
              <Select
                options={provinces?.data}
                value={province}
                onChange={onProvinceChangeHandler}
              />
            )}
            {error?.errors?.province?.[0] && (
              <p className="text-danger">{error?.errors?.province?.[0]}</p>
            )}
          </Col>
          <Col>
            <Label className="form-label">Facility</Label>
            {facilities?.data && (
              <Select
                options={facilities?.data}
                value={facility}
                isMulti={true}
                onChange={onFacilityChangeHandler}
              />
            )}
            {error?.errors?.facility?.[0] && (
              <p className="text-danger">{error?.errors?.facility?.[0]}</p>
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Item Categories</Label>
            {categories?.data && (
              <Select
                options={categories?.data}
                value={category}
                onChange={onCategoryChangeHandler}
              />
            )}
            {error?.errors?.category?.[0] && (
              <p className="text-danger">{error?.errors?.category?.[0]}</p>
            )}
          </Col>
          <Col>
            <Label className="form-label">Items</Label>
            {filteredItems && (
              <Select
                isMulti={true}
                options={[{ value: "all", label: "All" }, ...filteredItems]}
                value={item}
                onChange={onItemChangeHandler}
              />
            )}
            {error?.errors?.item?.[0] && (
              <p className="text-danger">{error?.errors?.item?.[0]}</p>
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Batch Number</Label>
            <Input
              name="batch_number"
              placeholder="Batch Number"
              type="text"
              onChange={onBatchNumberChange}
              value={batch_number}
            />
          </Col>
        </Row>
      </div>

      <div className="mb-3 ">
        <Row>
          <Col>
            <Label className="form-label">From Date</Label>
            <Flatpickr
              ref={dateFlatpickerfrom}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setDate(prev => {
                  return {
                    ...prev,
                    from: moment(value[0]).format("YYYY-MM-DD"),
                  }
                })
              }}
            />
          </Col>
          <Col>
            <Label className="form-label">To Date</Label>
            <Flatpickr
              ref={dateFlatpickerto}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setDate(prev => {
                  return { ...prev, to: moment(value[0]).format("YYYY-MM-DD") }
                })
              }}
            />
          </Col>
        </Row>
      </div>
      <ReportColumnSelector columns={columns} onToggle={onToggleColumn} onReorder={onReorder} />


      <div className="d-flex flex-wrap gap-2 mb-4">
        <Button
          type="submit"
          className="btn btn-sm btn-primary"
          color="primary"
          disabled={loading}
        >
          {loading ? "Please Wait..." : "Search"}
        </Button>
        <Button
          onClick={onClearHandler}
          className="btn btn-sm btn-danger"
          color="primary"
        >
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default ProviderConsumptionReporFilter2
